import React from 'react';
import styles from './LayoutWrapper.module.css';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import { NAV_VIS_CONFIG } from 'ui-home/src/misc/routes';
import { useMfeHostStore } from 'ui-home/src/utils/MfeHostStoreContext';

const escapeRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const normalize = (s) => (s.endsWith('/') && s !== '/' ? s.slice(0, -1) : s);

const matchExcludedHeaderPath = (pathname) => {
  const base = NAV_VIS_CONFIG.base || '';
  const normalizedPath = normalize(pathname);

  const exactHit = NAV_VIS_CONFIG.header.exact.some((p) => {
    const full = normalize(`${base}${p}`);
    return normalizedPath === full;
  });
  if (exactHit) return true;

  const patternHit = NAV_VIS_CONFIG.header.paramPatterns.some((p) => {
    const fullPattern = `${base}${p}`;
    const regex = new RegExp('^' + escapeRegex(fullPattern).replace(/:id\b/g, '[^/]+') + '/?$');
    return regex.test(normalizedPath);
  });
  if (patternHit) return true;

  return false;
};

const LayoutWrapper = ({ children }) => {
  const { snapshot: hostState } = useMfeHostStore();
  const isMenuPinned = useSelector((state) => state.user?.isMenuPinned);
  const pathname = window.location.pathname;

  const isExcluded = matchExcludedHeaderPath(pathname);

  const isCertificationListPage = pathname.includes('ECMv6/certification/list');

  let classes = styles.menuOpen;
  if (window.location.href?.includes('/login')) {
    classes = styles.menuClosed;
  } else if (!isMenuPinned) {
    classes = styles.menuClosed;
  } else if (!hostState.ui.mfeLayout.isHeaderVisible) {
    classes = styles.menuClosed;
  } else if (isCertificationListPage) {
    classes = styles.certificationListPage;
  }

  const isNewSidebarClass =
    window.location.href?.includes('/login') || !hostState.ui.mfeLayout.isHeaderVisible
      ? ''
      : styles.sideBarSpacing;

  const wrapperClasses = !isExcluded
    ? cx(
        classes,
        isNewSidebarClass,
        isNewSidebarClass && 'sideBarSpacing',
        isMenuPinned && 'Gen2NavMenuOpen'
      )
    : '';

  return <div className={wrapperClasses}>{children}</div>;
};

export default LayoutWrapper;
